import React from 'react';
import { formatDate } from '../Helpers/helpers'
import RandomImg from './randomimg'
const Note = (props) => {

  return (
    <li className="fieldnote">
      <div className="box">
        <article className="media">
          <div className="media-left">
            <RandomImg location={props.location} />
          </div>
          <div className="media-content">
            <div className="content">
              <span className="tag is-warning status">{!props.sync ? 'Not sync\'d' : 'Sync\'d'}</span>
              <p>
                {props.message}
              </p>
            </div>
            <nav className="level is-mobile">
              <div className="level-left">
                <span className="tag is-small level-item"><i className="fa fa-map-marker" aria-hidden="true"></i>{props.location}</span>
                <span className="tag is-small level-item"><i className="fa fa-info" aria-hidden="true"></i>{props.issue}</span>
              </div>
              <div className="level-right">
                <span className="tag is-small level-item"><i className="fa fa-calendar-o" aria-hidden="true"></i>{formatDate(props.created)}</span>
              </div>
            </nav>
          </div>
        </article>
      </div>
    </li>
  )
}

export default Note;



// WEBPACK FOOTER //
// ./src/Components/note.js